import React, {
    useCallback,
    useContext,
    useMemo,
    useState
} from 'react';
import CommonConstants from 'sg-common-constants';
import { TranslatorContext } from '@jutro/locale';
import SgSptConstants from 'sg-spt-constants';
import {
    Button,
    Link,
    Accordion,
    AccordionCard
} from '@jutro/components';
import htmlParser from 'html-react-parser';
import messages from './SgSptError.messages';

function SgSptError(props) {
    const {
        errorCodeT,
        errorCodeC
    } = props;

    const {
        SG_ERROR_CODES,
        SAGA_HOME
    } = CommonConstants;

    const {
        SG_TRAVEL_ERROR_REASONS
    } = SgSptConstants;

    const translator = useContext(TranslatorContext);
    const isAnnualDuplicateError = errorCodeC === SgSptConstants.SG_TRAVEL_ERROR_REASONS.ANNUAL_TRIP_DUPLICATE;

    const [openedAccordionId, setOpenedAccordionId] = useState(isAnnualDuplicateError
        ? 'sptNonPurchasableAccordion0' : 'sptNonPurchasableAccordion1');
    const onAccordionStateChange = (openedAccordionsIds) => {
        setOpenedAccordionId(openedAccordionsIds[0]);
    };

    const returnToHomepageButtonContent = useMemo(() => {
        return (
            <Link href={CommonConstants.SAGA_HOME}>
                <Button
                    className="sgButton sgPrimaryButton"
                    id="returnToHomepageButton"
                >
                    {translator(messages.TravelErrorHomeButton)}
                </Button>
            </Link>
        );
    }, []);

    const getDeclineMessageContent = useCallback(() => {
        switch (errorCodeC) {
            case SG_TRAVEL_ERROR_REASONS.TERMINAL_ILLNESS_OR_TRAVEL_AGAINST_ADVICE: // T0 C9330
                return (
                    <>
                        <p className="sgErrorPageSecondaryText">
                            {translator(messages.TravelErrorText1,
                                {
                                    link: (
                                        <Link
                                            rel="noreferrer"
                                            target="_blank"
                                            href={SgSptConstants.TRAVEL_ADVISER_DIRECTORY_LINK}
                                        >
                                            {translator(messages.TravelErrorHere)}
                                        </Link>
                                    )
                                })}
                        </p>
                        { returnToHomepageButtonContent }
                    </>
                );
            case SG_TRAVEL_ERROR_REASONS.ON_WAITING_LIST_AND_UNDIAGNOSED: // T0 C9331
                return (
                    <>
                        <p className="sgErrorPageSecondaryText">
                            {translator(messages.TravelErrorText2,
                                {
                                    link: (
                                        <Link
                                            rel="noreferrer"
                                            target="_blank"
                                            href={SgSptConstants.TRAVEL_ADVISER_DIRECTORY_LINK}
                                        >
                                            {translator(messages.TravelErrorHere)}
                                        </Link>
                                    )
                                })}
                        </p>
                        { returnToHomepageButtonContent }
                    </>
                );
            case SG_TRAVEL_ERROR_REASONS.UNDER_INVESTIGATION: // T0 C9332
                return (
                    <>
                        <p className="sgErrorPagePrimaryText">{translator(messages.TravelErrorText3)}</p>
                        <p className="sgErrorPageSecondaryText">{translator(messages.TravelErrorText4)}</p>
                        <p className="sgErrorPageSecondaryText">{translator(messages.TravelErrorText5)}</p>
                        <p className="sgErrorPageSecondaryText">
                            {translator(messages.TravelErrorText6,
                                {
                                    link: (
                                        <Link
                                            rel="noreferrer"
                                            target="_blank"
                                            href={SgSptConstants.TRAVEL_ADVISER_DIRECTORY_LINK}
                                        >
                                            {translator(messages.TravelErrorMoneyHelperDirectory)}
                                        </Link>
                                    )
                                })}
                        </p>
                        { returnToHomepageButtonContent }
                    </>
                );
            case SG_TRAVEL_ERROR_REASONS.MEDICAL_RISK_THRESHOLD_EXCEEDED: // T0 C9450
                return (
                    <>
                        <p className="sgErrorPageSecondaryText">
                            {translator(messages.TravelErrorText7,
                                {
                                    link: (
                                        <Link
                                            rel="noreferrer"
                                            target="_blank"
                                            href={SgSptConstants.TRAVEL_ADVISER_DIRECTORY_LINK}
                                        >
                                            {translator(messages.TravelErrorHere)}
                                        </Link>
                                    )
                                })}
                        </p>
                        { returnToHomepageButtonContent }
                    </>
                );
            default:
                return translator(messages.TravelDeclineDefaultMessage);
        }
    }, [errorCodeC]);

    const getReferralMessageContent = useCallback(() => {
        return (
            <div>
                <p>{translator(messages.TravelReferralErrorText1)}</p>
                <p>{translator(messages.TravelReferralErrorText2)}</p>
                <h3>{CommonConstants.SAGA_PHONE_NUMBERS.SAGA_TRAVEL_PHONE_NUMBER}</h3>
                <p>{translator(messages.TravelGenericErrorMessageText3)}</p>
            </div>
        );
    }, [errorCodeC]);

    const getDeclineHeader = useCallback(() => {
        switch (errorCodeC) {
            case SG_TRAVEL_ERROR_REASONS.TERMINAL_ILLNESS_OR_TRAVEL_AGAINST_ADVICE: // T0 C9330
            case SG_TRAVEL_ERROR_REASONS.ON_WAITING_LIST_AND_UNDIAGNOSED: // T0 C9331
            case SG_TRAVEL_ERROR_REASONS.MEDICAL_RISK_THRESHOLD_EXCEEDED: // T0 C9331
                return translator(messages.TravelErrorHeader1);
            case SG_TRAVEL_ERROR_REASONS.UNDER_INVESTIGATION: // T0 C9332
                return translator(messages.TravelErrorHeader2);
            default:
                return translator(messages.TravelErrorHeader1);
        }
    }, [errorCodeC]);

    const getReferralHeader = useCallback(() => {
        switch (errorCodeC) {
            default:
                return translator(messages.TravelErrorHeader1);
        }
    }, [errorCodeC]);


    const getOtherErrorsHeader = useCallback(() => {
        switch (errorCodeT) {
            case SG_ERROR_CODES.SAGA_QUOTATION_ERROR: // T6
                return translator(messages.TravelErrorHeader3);
            case SG_ERROR_CODES.SAGA_RETRIEVE_TIA_QUOTE: // T17
                return translator(messages.TravelTiaRetrievalErrorHeader);
            case SG_ERROR_CODES.SAGA_VERISK_EXCEPTION: // T19
                return translator(messages.TravelErrorHeader1);
            default:
                return '';
        }
    }, [errorCodeT, SG_ERROR_CODES]);

    const getOtherErrorsMessageContent = useCallback(() => {
        switch (errorCodeT) {
            case SG_ERROR_CODES.SAGA_RETRIEVE_TIA_QUOTE: // T17
                return (
                    <>
                        <p>
                            {translator(messages.TravelTiaRetrievalErrorMessage,
                                {
                                    link: (
                                        <Link
                                            href="#/journey"
                                        >
                                            {translator(messages.TravelTiaRetrievalStartNewQuote)}
                                        </Link>
                                    )
                                })}
                        </p>
                    </>
                );
            case SG_ERROR_CODES.SAGA_QUOTATION_ERROR: // T6
                return (
                    <>
                        <p className="sgErrorPagePrimaryText">{translator(messages.TravelGenericErrorMessageText1)}</p>
                        <p className="sgErrorPageSecondaryText">
                            {htmlParser(translator(messages.TravelGenericErrorMessageText2))}
                        </p>
                        <p className="sgErrorPageLinesOpen">{translator(messages.TravelGenericErrorMessageText3)}</p>
                    </>
                );
            case SG_ERROR_CODES.SAGA_VERISK_EXCEPTION: // T19
                return (
                    <>
                        <p className="sgErrorPagePrimaryText">{translator(messages.TravelGenericErrorMessageText1)}</p>
                        <p className="sgErrorPageSecondaryText">
                            {htmlParser(translator(messages.TravelGenericErrorMessageText2))}
                        </p>
                        <p className="sgErrorPageLinesOpen">{translator(messages.TravelGenericErrorMessageText3)}</p>
                        { returnToHomepageButtonContent }
                    </>
                );
            default:
                return '';
        }
    }, [errorCodeT, SG_ERROR_CODES, returnToHomepageButtonContent]);

    const getPaymentDeclineErrorContent = useCallback(() => {
        return (
            <>
                <p className="sgErrorPagePrimaryText">
                    {translator(messages.TravelErrorPaymentText1)}
                </p>
                <p className="sgErrorPageSecondaryText">
                    {translator(messages.TravelErrorPaymentText2)}
                </p>
                <p className="sgErrorPageSecondaryText">
                    <b>
                        {translator(messages.TravelErrorPaymentText3)}
                    </b>
                </p>
            </>
        );
    }, []);

    const phoneNumber = useMemo(() => { // for T9
        switch (openedAccordionId) {
            case 'sptNonPurchasableAccordion0': return SgSptConstants.PHONE_NUMBER_EXISTING_CUSTOMER;
            case 'sptNonPurchasableAccordion1': return SgSptConstants.PHONE_NUMBER_NEW_CUSTOMERS_MTA;
            case 'sptNonPurchasableAccordion2': return SgSptConstants.PHONE_NUMBER_NOT_CURRENTLY_INSURED;
            default: return SgSptConstants.PHONE_NUMBER_NOT_CURRENTLY_INSURED;
        }
    }, [openedAccordionId]);

    const renderExistingCustomerErrorContent = useCallback(() => {
        return (
            <>
                <Accordion
                    closeOthers
                    disabled={false}
                    id="sptNonPurchasableAccordion"
                    showFrame={false}
                    onUpdateAccordionStates={onAccordionStateChange}
                    defaultOpenedId={isAnnualDuplicateError ? 'sptNonPurchasableAccordion0' : 'sptNonPurchasableAccordion1'}
                    className="sgErrorPageAccordion"
                >
                    {isAnnualDuplicateError && (
                        <AccordionCard
                            id="sptNonPurchasableAccordion0"
                            isCollapsible
                            title={translator(messages.ExistingCustomerAnswer0)}
                            className="sgErrorPageAccordionCard"
                        >
                            <p>
                                {translator(messages.ExistingCustomerAnswer0Content1)}
                                <strong>{translator(messages.ExistingCustomerAnswer0Content2)}</strong>
                            </p>
                            <p>{htmlParser(translator(messages.ExistingCustomerAnswer0Content3))}</p>
                            <p>{htmlParser(translator(messages.ExistingCustomerAnswer0Content4))}</p>
                        </AccordionCard>
                    )}
                    <AccordionCard
                        id="sptNonPurchasableAccordion1"
                        isCollapsible
                        title={translator(messages.ExistingCustomerAnswer1)}
                        className="sgErrorPageAccordionCard"
                    >
                        <p>
                            {translator(messages.ExistingCustomerAnswer1Content1)}
                            <Link
                                target="_blank"
                                rel="noreferrer"
                                href="https://www.saga.co.uk/insurance/travel-insurance/existing-customers"
                            >
                                {translator(messages.Here)}
                            </Link>
                            .
                        </p>
                        <p>
                            {translator(messages.ExistingCustomerAnswer1Content2)}
                            <strong>{translator(messages.ExistingCustomerAnswer1Content3)}</strong>
                        </p>
                        <p>
                            {htmlParser(translator(messages.ExistingCustomerAnswer1Content4))}
                        </p>
                    </AccordionCard>
                    <AccordionCard
                        id="sptNonPurchasableAccordion2"
                        isCollapsible
                        title={translator(messages.ExistingCustomerAnswer2)}
                        className="sgErrorPageAccordionCard"
                    >
                        <p>
                            {translator(messages.ExistingCustomerAnswer2Content1)}
                        </p>
                        <p>
                            {htmlParser(translator(messages.ExistingCustomerAnswer2Content2))}
                        </p>
                        <p>
                            {htmlParser(translator(messages.ExistingCustomerAnswer2Content3))}
                        </p>
                    </AccordionCard>
                </Accordion>
                <div>
                    <p className="sgErrorPageBottomPhoneNumber">{translator(messages.CallUsOn, { number: phoneNumber })}</p>
                    <Link href={SAGA_HOME}>
                        <Button>
                            {translator(messages.SagaHomepage)}
                        </Button>
                    </Link>
                </div>
            </>
        );
    }, [phoneNumber, isAnnualDuplicateError]);

    const getFraudulentCardErrorContent = useCallback(() => {
        return (
            <>
                <p className="sgErrorPagePrimaryText">
                    {translator(messages.TravelFraudulentCardMessageText1)}
                </p>
                <p className="sgErrorPageSecondaryText">
                    {translator(messages.TravelFraudulentCardMessageText2)}
                </p>
                <p className="sgErrorPageSecondaryText">
                    {translator(messages.TravelFraudulentCardMessageText3)}
                </p>
                <p className="sgErrorPageSecondaryText">
                    {translator(messages.TravelErrorPaymentText3)}
                </p>
            </>
        );
    }, []);

    const headerContent = useMemo(() => {
        switch (errorCodeT) {
            case SG_ERROR_CODES.SAGA_DECLINE: // T0
                return getDeclineHeader();
            case SG_ERROR_CODES.SAGA_REFERRAL: // T1
                return getReferralHeader();
            case SG_ERROR_CODES.SAGA_RETRIEVING_AMENDED_OFFLINE: // T13
                return translator(messages.TravelRetrievalErrorHeader);
            case SG_ERROR_CODES.SAGA_NON_PURCHASABLE_QUOTE: // T9
                return translator(messages.ExistingCustomerHeader);
            case SG_ERROR_CODES.SAGA_QUOTATION_ERROR: // T6
            case SG_ERROR_CODES.SAGA_RETRIEVE_TIA_QUOTE: // T17
            case SG_ERROR_CODES.SAGA_VERISK_EXCEPTION: // T19
                return getOtherErrorsHeader();
            case SG_ERROR_CODES.SAGA_PAYMENT_FAILED: // T10
            case SG_ERROR_CODES.BARCLAYCARD_FRAUDULENT_CARD: // T8
                return translator(messages.TravelErrorHeaderPayment);
            default:
                return '';
        }
    }, [errorCodeT, SG_ERROR_CODES, getDeclineHeader, getReferralHeader, getOtherErrorsHeader]);

    const messageContent = useMemo(() => {
        switch (errorCodeT) {
            case SG_ERROR_CODES.SAGA_DECLINE: // T0
                return getDeclineMessageContent();
            case SG_ERROR_CODES.SAGA_REFERRAL: // T1
                return getReferralMessageContent();
            case SG_ERROR_CODES.SAGA_RETRIEVING_AMENDED_OFFLINE: // T13
                return htmlParser(translator(messages.TravelRetrievalErrorText));
            case SG_ERROR_CODES.SAGA_NON_PURCHASABLE_QUOTE: // T9
                return renderExistingCustomerErrorContent();
            case SG_ERROR_CODES.SAGA_QUOTATION_ERROR: // T6
            case SG_ERROR_CODES.SAGA_RETRIEVE_TIA_QUOTE: // T17
            case SG_ERROR_CODES.SAGA_VERISK_EXCEPTION: // T19
                return getOtherErrorsMessageContent();
            case SG_ERROR_CODES.SAGA_PAYMENT_FAILED: // T10
                return getPaymentDeclineErrorContent();
            case SG_ERROR_CODES.BARCLAYCARD_FRAUDULENT_CARD: // T8
                return getFraudulentCardErrorContent();
            default:
                return '';
        }
    }, [errorCodeT, getDeclineMessageContent, getReferralMessageContent, phoneNumber, getOtherErrorsMessageContent, SG_ERROR_CODES]);


    return (
        <div>
            <h1>{headerContent}</h1>
            <div>{messageContent}</div>
        </div>
    );
}

export default SgSptError;
